/**
 * --------------------------------------------------
 * components/MoibleMenu.ts
 * Mobile Menu
 * --------------------------------------------------
*/

import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class MobileMenu extends ThemeComponent {
    @Ref({ required: false }) stateTrigger!: HTMLElement[];
    @Ref({ required: false }) stateNav!: HTMLElement[];
    @Ref({ required: false }) highlights!: HTMLElement[];
    @Ref({ required: false }) grandchildToggle!: HTMLButtonElement[];
    private _onOpenChange = new SimpleEvent<string>();
    public get onOpenChange() {
        return this._onOpenChange.asEvent();
    }
    init() {
        this.setEventListeners();
        if (window.quickLaunch?.megaMenu) {
            this.handleMagaMenu();
        }
    }

    /**
     * Set event listeners.
     */
    setEventListeners() {
        if (this.stateTrigger.length > 0) {
            for (const trigger of this.stateTrigger) {
                this.$listen(trigger, 'click', () => {
                    this.handleStateChange(trigger, trigger.dataset.child);
                });
            }
        }

        if (this.grandchildToggle.length > 0) {
            for (const toggle of this.grandchildToggle) {
                this.$listen(toggle, 'click', () => {
                    toggle.classList.toggle('is-active');
                    toggle.nextElementSibling?.classList.toggle('is-active');
                });
            }
        }
    }

    /**
     * Handle multistate menu change.
     * @param child - trigger child menu handle
     */
    handleStateChange(parent: HTMLElement, child: string | undefined) {
        if (this.stateTrigger.length === 0) { return; }

        for (const nav of this.stateNav) {
            nav.classList.remove('is-active');
            if (nav.dataset.parent === child) {
                nav.classList.add('is-active');
            }
        }

        for (const trigger of this.stateTrigger) {
            trigger.classList.remove('is-active');
            if (trigger === parent) {
                trigger.classList.add('is-active');
            }
        }
    }

    /**
     * Handle mega menu.
     */
    handleMagaMenu() {
        for (const highlights of this.highlights) {
            highlights?.classList.add('is-active');
        }
    }
}
